import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import AuthenticateService from '../../AuthenticateService';

const money = (n) => `₦${(parseFloat(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Small dashboard summary of what the referral programme has earned so far; opens the full Refer & Earn page. */
const ReferralEarningsCard = () => {
  const { http } = AuthenticateService();
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [stats, setStats] = useState({});

  useEffect(() => {
    let cancelled = false;
    http.get('/referral/summary')
      .then((res) => {
        if (cancelled) return;
        if (res.data.status === true) {
          setStats(res.data.data?.stats || {});
        } else {
          setFailed(true);
        }
      })
      .catch(() => { if (!cancelled) setFailed(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link to="/referral" className="text-decoration-none">
      <div
        className="card h-100 text-white"
        style={{ background: 'linear-gradient(135deg, #4D0E8F, #7B2CBF)' }}
      >
        <div className="card-body d-flex flex-column">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center me-2" style={{ width: 36, height: 36 }}>
                <FontAwesomeIcon icon={faGift} />
              </div>
              <span className="fw-semi-bold">Referral Earnings</span>
            </div>
            <FontAwesomeIcon icon={faChevronRight} className="text-white-50" />
          </div>

          {loading ? (
            <div className="placeholder-glow">
              <span className="placeholder col-6 bg-white bg-opacity-50" style={{ height: 28, display: 'inline-block', borderRadius: 6 }}></span>
            </div>
          ) : failed ? (
            <div className="fs-3 fw-bold">Refer & Earn</div>
          ) : (
            <div className="fs-3 fw-bold">{money(stats.total_earned)}</div>
          )}

          <div className="text-white-50 fs--1 mt-1">
            {failed ? 'Tap to view your referral link' : 'Total earned, already paid into your wallet'}
          </div>

          {!loading && !failed && (
            <div className="mt-2 fs--1">
              {stats.total_referred || 0} {parseInt(stats.total_referred, 10) === 1 ? 'person' : 'people'} referred
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ReferralEarningsCard;
